@if (notEligible) {
  <div class="upgrade-prompt">
    <ion-icon name="lock-closed" class="lock-icon"></ion-icon>
    @if (subscriptionRequired) {
      <h3>{{ 'playback-eligibility.subscription-required' | translate }}</h3>
      <p>{{ 'playback-eligibility.subscription-message' | translate }}</p>
      <ion-button expand="block" shape="round" (click)="subscribe()">
        <ion-icon slot="start" name="star"></ion-icon>
        {{ 'playback-eligibility.subscribe' | translate }}
      </ion-button>
    } @else {
      <h3>{{ 'playback-eligibility.daily-limit-title' | translate }}</h3>
      @if (hasUpgradePlans) {
        <p>{{ 'playback-eligibility.upgrade-message' | translate }}</p>
        <ion-button expand="block" shape="round" (click)="goToUpgrade()">
          <ion-icon slot="start" name="star"></ion-icon>
          {{ 'playback-eligibility.upgrade' | translate }}
        </ion-button>
      } @else {
        <p>{{ 'playback-eligibility.daily-limit-message' | translate }}</p>
        <ion-button expand="block" shape="round" (click)="goHome()">
          <ion-icon slot="start" name="home"></ion-icon>
          {{ 'plans.go-home' | translate }}
        </ion-button>
      }
    }
  </div>
} @else {
  <ng-content></ng-content>
}

